module.exports = __webpack_public_path__ + "static/media/close-24px.8f1f9002.svg";